
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createcontacto3xpgy } from '../../api/contacto3xpgy.api'

import './contactovc142.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pcontactovc142 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6931c2908e5aed52dc8aa242" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
        <a
          target=""
          className=""
          id="iumht8"
          href="/"
        >
          
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
        </a>
        
      <div id="itmdc" className="">
      
        <a
          target=""
          className="link-menu "
          id="iijdu7"
          href="/sobrenosotros"
        >
          
    <div id="inoik6" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijau3l"
          href="/proyectos"
        >
          
    <div id="i1h6oa" className="">
    <>Proyectos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ix608d"
          href="/campanas"
        >
          
    <div id="ib1jkk" className="">
    <>Campañas</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="imshx9"
          href="/impacto"
        >
          
    <div id="itxxvc" className="">
    <>Impacto Social</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i2f03g"
          href="/convenios"
        >
          
    <div id="ido781" className="">
    <>Convenios</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="is3mic"
          href="/transparencia"
        >
          
    <div id="i0541i" className="">
    <>Transparencia</>
    </div>
    
        </a>
        
      </div>
      
        <a
          target=""
          className="boton-primario "
          id="iiit99"
          href="/contacto"
        >
          
    <div id="i1fieg" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/proyectos"
        type=""
      >
        <>Proyectos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/campanas"
        type=""
      >
        <>Campañas</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/impacto"
        type=""
      >
        <>Impacto social</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/convenios"
        type=""
      >
        <>Convenios</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/transparencia"
        type=""
      >
        <>Transparencia</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ingwtg">
        <>Contacto</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div className="" id="i7p7tx">
        
      <span className="" id="">
        
      </span>
      <>Ponte en contacto con nosotros</>
      </div>
      
      <div className="" id="ipqtra">
        <>Si eres parte de una entidad pública, organización internacional, empresa privada o colectivo ciudadano y deseas conocer más sobre nuestros proyectos o explorar alianzas, escríbenos a través del siguiente formulario.</>
      </div>
      
      </div>
      
      <div id="iuo301" className="">
      
        <div className="" id="imvav">
          
      <form
        id="itp66x"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createcontacto3xpgy({
						token: 'aasdas',
						nombremzbcy: e.target.nombremzbcy.value,
						correoznnk: e.target.correoznnk.value,
						telefonoiahke: e.target.telefonoiahke.value,
						organizacin7a8awi: e.target.organizacin7a8awi.value,
						undefined: e.target.undefined.value,
					});
					alert("Se envío de manera exitosa");
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="izq7ef" className="">
      
      <div id="idfdgl" className="">
      
      <label id="icsamv" className="etiqueta ">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombremzbcy"
        type="text"
        placeholder="Nombre"
        className="input "
        id="imq95i"
      />
      
      </div>
      
      <div id="iecwp7" className="">
      
      <label id="iec95r" className="etiqueta ">
      <>Correo</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="correoznnk"
        type="text"
        placeholder="Correo"
        className="input "
        id="it0rhw"
      />
      
      </div>
      
      </div>
      
      <div id="il8zai" className="">
      
      <div id="i569ge" className="">
      
      <label id="i28jee" className="etiqueta ">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telefonoiahke"
        type="text"
        placeholder="teléfono"
        className="input "
        id="ijkci8"
      />
      
      </div>
      
      <div id="iyiv3k" className="">
      
      <label id="i615yy" className="etiqueta ">
      <>Organización</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="organizacin7a8awi"
        type="text"
        placeholder="organización"
        className="input "
        id="iw69hl"
      />
      
      </div>
      
      </div>
      
    <div id="iog6ke" className="">
    
      <label id="i23qii" className="etiqueta ">
      <>Mensaje</>
      </label>
      
      <br className="" id="" />
      
      <textarea name="mensajed8wp2j" className="input " id="iyh3fo">
        
      </textarea>
      
    </div>
    
      <button
        type="submit"
        name=""
        id="ixpk8e"
        className="boton-primario f-100 "
        
      >
      
      <div id="ixxg64" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="icvuhe">
        <>Fundación Petrus</>
      </span>
      
      </div>
      
      <img
        className=""
        id="ifb4hr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="invc11" className="">
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Páginas</>
      </div>
      
      <div className="" id="igdgp1">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="io8u0g">
        <>Proyectos</>
      </div>
      
      <div className="" id="ifh4ms">
        <>Impacto Social</>
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Más información</>
      </div>
      
      <div className="" id="il1rnw">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcontactovc142);
  